import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Category} from "../../models/category";

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {User} from "../../models";
import {first} from "rxjs/operators";
import {UserService} from "../../services";
import {Card} from "../../models/card";
import {Service} from "../../models/service";
import {ServiceService} from "../../services/service.service";
import {Services} from "../../models/services";

@Component({
    selector: 'minus-service-form-dialog',
    templateUrl: './minusServiceDialog.component.html',
    styleUrls: ['./minusServiceDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class MinusServiceDialogComponent {
    action: string;
    customer: User;
    dialogTitle: string;
    dialogRef: any;
    card: Card;
    form: FormGroup;
    services: Service[];

    /**
     * Constructor
     *
     * @param {MatDialogRef<MinusServiceDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<MinusServiceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private userService: UserService,
        private formBuilder: FormBuilder,
        private serviceService: ServiceService,
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;
        this.customer = _data.customer;
        this.card = _data.card;

        this.form = this.formBuilder.group({
            service: [''],
        });

        this.serviceService.getAll()
            .pipe(first())
            .subscribe((x: Services) => {
                this.services = x.items;
            });
    }

    minusService(customer: User) {
        this.dialogRef = this._matDialog.open(MinusServiceDialogComponent, {
            panelClass: 'contact-form-dialog',
            data: {
                action: 'edit',
                customer: customer
            },
            width: '500px',
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }


                // let customerData = response.getRawValue();
                // customer.description = customerData.description;
                //
                // this.userService.updateCustomer(customer.id, customer)
                //     .pipe(first())
                //     .subscribe(
                //         (customer: User) => {
                //             this.customer = customer
                //         },
                //         error => {
                //             console.log(error);
                //         });

            }, (err) => {
                console.log(err);
            });
    }

}
